







































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import Wallet from '@/models/Accounts/DepositAccounts/Wallets/Wallet';
import AdjustmentRequest from '@/models/Accounts/DepositAccounts/Tools/AdjustmentRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CurrencyUtils from '@/lib/currencyUtils';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'AdjustmentTool' })
export default class extends SaascadaVueDialog {

    dialog: boolean = false;
    request = new AdjustmentRequest();
    selectedWallet: Wallet = new Wallet();
    adjustmentAmount: number = 0;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new AdjustmentRequest();
            this.selectedWallet = new Wallet();
            this.adjustmentAmount = 0;
            // If there is only one wallet then preselect the only wallet
            if (this.hasOnlyOneWallet) {
                this.selectedWallet = this.account.wallets[0];
            }
        }
    }

    get account() {
        return DepositAccountModule.depositAccount;
    }

    get hasOnlyOneWallet() {
        return this.account.wallets.length === 1;
    }

    get debitCreditOptions() {
        return ListUtils.debitCreditOptions();
    }

    get transactionTypeOptions() {
        return ListUtils.transactionTypeOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            this.request.accountId = this.account.id;
            this.request.walletId = this.selectedWallet.id;
            this.request.amount.currency = this.selectedWallet.currency;
            this.request.amount.amount = CurrencyUtils.convertDecimalStringToAmountString(this.adjustmentAmount);

            await DepositAccountModule.makeAdjustment(this.request);
        }
    }

    close() {
        this.dialog = false;
    }

};
